import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'

import { Observable, map } from 'rxjs'

import { ApiHttpService } from '@flowx/designer/shared/api/api-http.service'
import { requestScopeContext } from '@flowx/designer/shared/api/request-scope.token'

/** The designer-user service's per-user preferences, reached through its `designer-user` ingress prefix. */
@Injectable({ providedIn: 'root' })
export class UserPreferencesApiService extends ApiHttpService {
  constructor() {
    const baseUrl = inject<string>('BASE_URL' as any)
    const httpClient = inject(HttpClient)
    super(`${baseUrl}/designer-user/api/design-user/preferences`, httpClient)
  }

  /** Not checked against the user's access: the workspace may since have been deleted or revoked. */
  getLastUsedWorkspaceId(): Observable<string | null> {
    return this.get('last-used-wks').pipe(
      map(({ lastUsedWorkspaceId }: { lastUsedWorkspaceId: string | null }) => lastUsedWorkspaceId)
    )
  }

  /**
   * The workspace travels in the `Fx-Workspace-Id` header, which the interceptor would otherwise
   * fill with the route's. Saved asynchronously: a read straight after may still return the old one.
   */
  setLastUsedWorkspaceId(workspaceId: string): Observable<void> {
    return this.post('last-used-wks', null, {
      context: requestScopeContext({ type: 'workspace', workspaceId }),
    })
  }
}
